import { Component, Inject, OnInit } from '@angular/core';
import { AlertType } from '../confirm-dialog/confirm-dialog.component';
import {MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  TaskRecordCustomStatisticsSaveDialogData,
  TaskRecordCustomStatisticsSaveDialogResult
} from "../../admin/task/task-record/task-record-custom-statistics/task-record-custom-statistics-save-dialog/task-record-custom-statistics-save-dialog.component";

@Component({
  selector: 'app-mat-confirm-dialog',
  templateUrl: './mat-confirm-dialog.component.html',
  styleUrls: ['./mat-confirm-dialog.component.scss']
})
export class MatConfirmDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MatConfirmDialogComponent, boolean>,
              @Inject(MAT_DIALOG_DATA) public data: MatConfirmDialogData) {
  }

  public static openDialog(
    dialog: MatDialog,
    data: MatConfirmDialogData,
    resultCallback: (result?: boolean) => void) {
    const dialogRef = dialog.open(MatConfirmDialogComponent, {
      data: data
    });
    dialogRef.afterClosed().subscribe((result?: boolean) => {
      resultCallback(result);
    });
  }

  ngOnInit() {
  }

  get titleEnabled(): boolean {
    return this.data.titleKey !== undefined && this.data.titleKey.length > 0;
  }

  get messageEnabled(): boolean {
    return this.data.messageKey !== undefined && this.data.messageKey.length > 0;
  }

  get alertType(): AlertType {
    return this.data.alertType ? this.data.alertType : AlertType.INFO;
  }

  get titleKey(): string {
    return this.titleEnabled ? this.data.titleKey! : '';
  }

  get messageKey(): string {
    return this.messageEnabled ? this.data.messageKey! : '';
  }

  get messageParams() {
    return this.data.messageParameters !== undefined ? this.data.messageParameters : {};
  }

  get negativeButtonEnabled(): boolean {
    return this.data.negativeButtonEnabled === undefined ? true : this.data.negativeButtonEnabled;
  }

  get positiveButtonEnabled(): boolean {
    return this.data.positiveButtonEnabled === undefined ? true : this.data.positiveButtonEnabled;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}

export interface MatConfirmDialogData {
  titleKey?: string;
  alertType?: AlertType;
  messageKey?: string;
  negativeButtonEnabled?: boolean;
  positiveButtonEnabled?: boolean;
  messageParameters?: {};
}

export const MATERIAL_DIALOG_CONFIG_PROVIDER = {
  provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {disableClose: true, hasBackdrop: true}
};
